import { render, staticRenderFns } from "./RecipeJournalPage.vue?vue&type=template&id=be8fc09a&scoped=true&"
import script from "./RecipeJournalPage.vue?vue&type=script&lang=js&"
export * from "./RecipeJournalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8fc09a",
  null
  
)

export default component.exports